import { render, staticRenderFns } from "./HraSummary.vue?vue&type=template&id=07066e9e"
import script from "./HraSummary.vue?vue&type=script&lang=js"
export * from "./HraSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports